// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/team.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../buf/validate/validate_pb";
import type { Agent, CustomClaim, ServiceTokenAgent } from "../../auth/v1/agent_pb";
import { file_chalk_auth_v1_agent } from "../../auth/v1/agent_pb";
import { file_chalk_auth_v1_audit } from "../../auth/v1/audit_pb";
import type { DisplayAgent, DisplayServiceTokenAgent } from "../../auth/v1/displayagent_pb";
import { file_chalk_auth_v1_displayagent } from "../../auth/v1/displayagent_pb";
import type { FeaturePermission, FeaturePermissions } from "../../auth/v1/featurepermission_pb";
import { file_chalk_auth_v1_featurepermission } from "../../auth/v1/featurepermission_pb";
import type { Permission } from "../../auth/v1/permissions_pb";
import { file_chalk_auth_v1_permissions } from "../../auth/v1/permissions_pb";
import type { DeploymentBuildProfile, Environment, EnvironmentObjectStorageConfig, VectorDBKind } from "./environment_pb";
import { file_chalk_server_v1_environment } from "./environment_pb";
import type { FieldChange } from "../../utils/v1/field_change_pb";
import { file_chalk_utils_v1_field_change } from "../../utils/v1/field_change_pb";
import { file_chalk_utils_v1_sensitive } from "../../utils/v1/sensitive_pb";
import type { FieldMask, Timestamp, Value } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/server/v1/team.proto.
 */
export const file_chalk_server_v1_team: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_chalk_auth_v1_agent, file_chalk_auth_v1_audit, file_chalk_auth_v1_displayagent, file_chalk_auth_v1_featurepermission, file_chalk_auth_v1_permissions, file_chalk_server_v1_environment, file_chalk_utils_v1_field_change, file_chalk_utils_v1_sensitive, file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp]);

/**
 * @generated from message chalk.server.v1.GetEnvRequest
 */
export type GetEnvRequest = Message<"chalk.server.v1.GetEnvRequest"> & {
};

/**
 * Describes the message chalk.server.v1.GetEnvRequest.
 * Use `create(GetEnvRequestSchema)` to create a new message.
 */
export const GetEnvRequestSchema: GenMessage<GetEnvRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 0);

/**
 * @generated from message chalk.server.v1.GetEnvResponse
 */
export type GetEnvResponse = Message<"chalk.server.v1.GetEnvResponse"> & {
  /**
   * @generated from field: chalk.server.v1.Environment environment = 1;
   */
  environment?: Environment;
};

/**
 * Describes the message chalk.server.v1.GetEnvResponse.
 * Use `create(GetEnvResponseSchema)` to create a new message.
 */
export const GetEnvResponseSchema: GenMessage<GetEnvResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 1);

/**
 * @generated from message chalk.server.v1.GetEnvIncludingArchivedRequest
 */
export type GetEnvIncludingArchivedRequest = Message<"chalk.server.v1.GetEnvIncludingArchivedRequest"> & {
};

/**
 * Describes the message chalk.server.v1.GetEnvIncludingArchivedRequest.
 * Use `create(GetEnvIncludingArchivedRequestSchema)` to create a new message.
 */
export const GetEnvIncludingArchivedRequestSchema: GenMessage<GetEnvIncludingArchivedRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 2);

/**
 * @generated from message chalk.server.v1.GetEnvIncludingArchivedResponse
 */
export type GetEnvIncludingArchivedResponse = Message<"chalk.server.v1.GetEnvIncludingArchivedResponse"> & {
  /**
   * @generated from field: chalk.server.v1.Environment environment = 1;
   */
  environment?: Environment;
};

/**
 * Describes the message chalk.server.v1.GetEnvIncludingArchivedResponse.
 * Use `create(GetEnvIncludingArchivedResponseSchema)` to create a new message.
 */
export const GetEnvIncludingArchivedResponseSchema: GenMessage<GetEnvIncludingArchivedResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 3);

/**
 * @generated from message chalk.server.v1.GetEnvironmentsRequest
 */
export type GetEnvironmentsRequest = Message<"chalk.server.v1.GetEnvironmentsRequest"> & {
  /**
   * @generated from field: string project = 1;
   */
  project: string;
};

/**
 * Describes the message chalk.server.v1.GetEnvironmentsRequest.
 * Use `create(GetEnvironmentsRequestSchema)` to create a new message.
 */
export const GetEnvironmentsRequestSchema: GenMessage<GetEnvironmentsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 4);

/**
 * @generated from message chalk.server.v1.GetEnvironmentsResponse
 */
export type GetEnvironmentsResponse = Message<"chalk.server.v1.GetEnvironmentsResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.Environment environments = 2;
   */
  environments: Environment[];
};

/**
 * Describes the message chalk.server.v1.GetEnvironmentsResponse.
 * Use `create(GetEnvironmentsResponseSchema)` to create a new message.
 */
export const GetEnvironmentsResponseSchema: GenMessage<GetEnvironmentsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 5);

/**
 * @generated from message chalk.server.v1.GetAgentRequest
 */
export type GetAgentRequest = Message<"chalk.server.v1.GetAgentRequest"> & {
};

/**
 * Describes the message chalk.server.v1.GetAgentRequest.
 * Use `create(GetAgentRequestSchema)` to create a new message.
 */
export const GetAgentRequestSchema: GenMessage<GetAgentRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 6);

/**
 * @generated from message chalk.server.v1.GetAgentResponse
 */
export type GetAgentResponse = Message<"chalk.server.v1.GetAgentResponse"> & {
  /**
   * @generated from field: chalk.auth.v1.Agent agent = 1;
   */
  agent?: Agent;
};

/**
 * Describes the message chalk.server.v1.GetAgentResponse.
 * Use `create(GetAgentResponseSchema)` to create a new message.
 */
export const GetAgentResponseSchema: GenMessage<GetAgentResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 7);

/**
 * @generated from message chalk.server.v1.GetDisplayAgentRequest
 */
export type GetDisplayAgentRequest = Message<"chalk.server.v1.GetDisplayAgentRequest"> & {
  /**
   * Optional: if provided, fetches the agent with this ID instead of the current agent.
   * The agent must belong to the same team as the caller.
   *
   * @generated from field: optional string agent_id = 1;
   */
  agentId?: string;
};

/**
 * Describes the message chalk.server.v1.GetDisplayAgentRequest.
 * Use `create(GetDisplayAgentRequestSchema)` to create a new message.
 */
export const GetDisplayAgentRequestSchema: GenMessage<GetDisplayAgentRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 8);

/**
 * @generated from message chalk.server.v1.GetDisplayAgentResponse
 */
export type GetDisplayAgentResponse = Message<"chalk.server.v1.GetDisplayAgentResponse"> & {
  /**
   * @generated from field: chalk.auth.v1.DisplayAgent agent = 1;
   */
  agent?: DisplayAgent;
};

/**
 * Describes the message chalk.server.v1.GetDisplayAgentResponse.
 * Use `create(GetDisplayAgentResponseSchema)` to create a new message.
 */
export const GetDisplayAgentResponseSchema: GenMessage<GetDisplayAgentResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 9);

/**
 * @generated from message chalk.server.v1.Team
 */
export type Team = Message<"chalk.server.v1.Team"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string slug = 3;
   */
  slug: string;

  /**
   * @generated from field: optional string logo = 4;
   */
  logo?: string;

  /**
   * @generated from field: repeated chalk.server.v1.Project projects = 5;
   */
  projects: Project[];

  /**
   * @generated from field: optional string scim_provider = 6;
   */
  scimProvider?: string;

  /**
   * TODO: really a structured object.
   *
   * @generated from field: map<string, google.protobuf.Value> spec_config_json = 7;
   */
  specConfigJson: { [key: string]: Value };

  /**
   * google.protobuf.Timestamp created_at = 8;
   * google.protobuf.Timestamp updated_at = 9;
   *
   * @generated from field: map<string, google.protobuf.Value> internal_metadata = 10;
   */
  internalMetadata: { [key: string]: Value };

  /**
   * @generated from field: map<string, google.protobuf.Value> customer_metadata = 11;
   */
  customerMetadata: { [key: string]: Value };

  /**
   * @generated from field: chalk.server.v1.TeamCreationType team_creation_type = 12;
   */
  teamCreationType: TeamCreationType;

  /**
   * @generated from field: optional string company_name = 13;
   */
  companyName?: string;

  /**
   * @generated from field: chalk.server.v1.TeamAccountType account_type = 14;
   */
  accountType: TeamAccountType;
};

/**
 * Describes the message chalk.server.v1.Team.
 * Use `create(TeamSchema)` to create a new message.
 */
export const TeamSchema: GenMessage<Team> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 10);

/**
 * @generated from message chalk.server.v1.Project
 */
export type Project = Message<"chalk.server.v1.Project"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string team_id = 2;
   */
  teamId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: repeated chalk.server.v1.Environment environments = 4;
   */
  environments: Environment[];

  /**
   * @generated from field: optional string git_repo = 5;
   */
  gitRepo?: string;

  /**
   * @generated from field: map<string, google.protobuf.Value> internal_metadata = 6;
   */
  internalMetadata: { [key: string]: Value };

  /**
   * @generated from field: map<string, google.protobuf.Value> customer_metadata = 7;
   */
  customerMetadata: { [key: string]: Value };

  /**
   * @generated from field: optional string default_environment_id = 8;
   */
  defaultEnvironmentId?: string;

  /**
   * Free-form, customer-authored description of the project, rendered as Markdown
   * in the dashboard. Unset means "no description".
   *
   * @generated from field: optional string description = 9;
   */
  description?: string;
};

/**
 * Describes the message chalk.server.v1.Project.
 * Use `create(ProjectSchema)` to create a new message.
 */
export const ProjectSchema: GenMessage<Project> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 11);

/**
 * @generated from message chalk.server.v1.CreateTeamRequest
 */
export type CreateTeamRequest = Message<"chalk.server.v1.CreateTeamRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string slug = 2;
   */
  slug: string;

  /**
   * @generated from field: optional string logo = 3;
   */
  logo?: string;
};

/**
 * Describes the message chalk.server.v1.CreateTeamRequest.
 * Use `create(CreateTeamRequestSchema)` to create a new message.
 */
export const CreateTeamRequestSchema: GenMessage<CreateTeamRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 12);

/**
 * @generated from message chalk.server.v1.CreateTeamResponse
 */
export type CreateTeamResponse = Message<"chalk.server.v1.CreateTeamResponse"> & {
  /**
   * @generated from field: chalk.server.v1.Team team = 1;
   */
  team?: Team;
};

/**
 * Describes the message chalk.server.v1.CreateTeamResponse.
 * Use `create(CreateTeamResponseSchema)` to create a new message.
 */
export const CreateTeamResponseSchema: GenMessage<CreateTeamResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 13);

/**
 * @generated from message chalk.server.v1.CreateProjectRequest
 */
export type CreateProjectRequest = Message<"chalk.server.v1.CreateProjectRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message chalk.server.v1.CreateProjectRequest.
 * Use `create(CreateProjectRequestSchema)` to create a new message.
 */
export const CreateProjectRequestSchema: GenMessage<CreateProjectRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 14);

/**
 * @generated from message chalk.server.v1.CreateProjectResponse
 */
export type CreateProjectResponse = Message<"chalk.server.v1.CreateProjectResponse"> & {
  /**
   * @generated from field: chalk.server.v1.Project project = 1;
   */
  project?: Project;
};

/**
 * Describes the message chalk.server.v1.CreateProjectResponse.
 * Use `create(CreateProjectResponseSchema)` to create a new message.
 */
export const CreateProjectResponseSchema: GenMessage<CreateProjectResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 15);

/**
 * @generated from message chalk.server.v1.UpdateProjectOperation
 */
export type UpdateProjectOperation = Message<"chalk.server.v1.UpdateProjectOperation"> & {
  /**
   * @generated from field: optional string name = 1;
   */
  name?: string;

  /**
   * @generated from field: optional string git_repo = 2;
   */
  gitRepo?: string;

  /**
   * Markdown description. Present-but-empty clears the description.
   *
   * @generated from field: optional string description = 3;
   */
  description?: string;
};

/**
 * Describes the message chalk.server.v1.UpdateProjectOperation.
 * Use `create(UpdateProjectOperationSchema)` to create a new message.
 */
export const UpdateProjectOperationSchema: GenMessage<UpdateProjectOperation> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 16);

/**
 * @generated from message chalk.server.v1.UpdateProjectRequest
 */
export type UpdateProjectRequest = Message<"chalk.server.v1.UpdateProjectRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: chalk.server.v1.UpdateProjectOperation update = 2;
   */
  update?: UpdateProjectOperation;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 3;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message chalk.server.v1.UpdateProjectRequest.
 * Use `create(UpdateProjectRequestSchema)` to create a new message.
 */
export const UpdateProjectRequestSchema: GenMessage<UpdateProjectRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 17);

/**
 * @generated from message chalk.server.v1.UpdateProjectResponse
 */
export type UpdateProjectResponse = Message<"chalk.server.v1.UpdateProjectResponse"> & {
  /**
   * @generated from field: chalk.server.v1.Project project = 1;
   */
  project?: Project;
};

/**
 * Describes the message chalk.server.v1.UpdateProjectResponse.
 * Use `create(UpdateProjectResponseSchema)` to create a new message.
 */
export const UpdateProjectResponseSchema: GenMessage<UpdateProjectResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 18);

/**
 * @generated from message chalk.server.v1.ArchiveProjectRequest
 */
export type ArchiveProjectRequest = Message<"chalk.server.v1.ArchiveProjectRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message chalk.server.v1.ArchiveProjectRequest.
 * Use `create(ArchiveProjectRequestSchema)` to create a new message.
 */
export const ArchiveProjectRequestSchema: GenMessage<ArchiveProjectRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 19);

/**
 * @generated from message chalk.server.v1.ArchiveProjectResponse
 */
export type ArchiveProjectResponse = Message<"chalk.server.v1.ArchiveProjectResponse"> & {
};

/**
 * Describes the message chalk.server.v1.ArchiveProjectResponse.
 * Use `create(ArchiveProjectResponseSchema)` to create a new message.
 */
export const ArchiveProjectResponseSchema: GenMessage<ArchiveProjectResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 20);

/**
 * @generated from message chalk.server.v1.CreateEnvironmentRequest
 */
export type CreateEnvironmentRequest = Message<"chalk.server.v1.CreateEnvironmentRequest"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: bool is_default = 3;
   */
  isDefault: boolean;

  /**
   * @generated from field: string source_bundle_bucket = 4;
   */
  sourceBundleBucket: string;

  /**
   * @generated from field: optional string kube_cluster_id = 5;
   */
  kubeClusterId?: string;

  /**
   * @generated from field: optional string engine_docker_registry_path = 6;
   */
  engineDockerRegistryPath?: string;

  /**
   * @generated from field: optional string environment_id_override = 7;
   */
  environmentIdOverride?: string;

  /**
   * Whether to bootstrap cloud infrastructure.
   *
   * @generated from field: bool managed = 8;
   */
  managed: boolean;
};

/**
 * Describes the message chalk.server.v1.CreateEnvironmentRequest.
 * Use `create(CreateEnvironmentRequestSchema)` to create a new message.
 */
export const CreateEnvironmentRequestSchema: GenMessage<CreateEnvironmentRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 21);

/**
 * @generated from message chalk.server.v1.CreateEnvironmentResponse
 */
export type CreateEnvironmentResponse = Message<"chalk.server.v1.CreateEnvironmentResponse"> & {
  /**
   * @generated from field: chalk.server.v1.Environment environment = 1;
   */
  environment?: Environment;
};

/**
 * Describes the message chalk.server.v1.CreateEnvironmentResponse.
 * Use `create(CreateEnvironmentResponseSchema)` to create a new message.
 */
export const CreateEnvironmentResponseSchema: GenMessage<CreateEnvironmentResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 22);

/**
 * @generated from message chalk.server.v1.UpdateEnvironmentOperation
 */
export type UpdateEnvironmentOperation = Message<"chalk.server.v1.UpdateEnvironmentOperation"> & {
  /**
   * @generated from field: optional bool is_default = 6;
   */
  isDefault?: boolean;

  /**
   * @generated from field: optional string specs_config_json = 1;
   */
  specsConfigJson?: string;

  /**
   * Customer-supplied env vars injected verbatim into engine pods; they
   * routinely carry datasource credentials, so redact from the audit log.
   *
   * @generated from field: map<string, string> additional_env_vars = 2;
   */
  additionalEnvVars: { [key: string]: string };

  /**
   * May embed pip index URLs with tokens in the userinfo.
   *
   * @generated from field: optional string private_pip_repositories = 3;
   */
  privatePipRepositories?: string;

  /**
   * @generated from field: optional string online_store_kind = 12;
   */
  onlineStoreKind?: string;

  /**
   * Accepts a raw URI or a KMS secret name on writes; reads return the backing KMS name.
   *
   * @generated from field: optional string online_store_secret = 4;
   */
  onlineStoreSecret?: string;

  /**
   * @generated from field: optional string feature_store_secret = 5;
   */
  featureStoreSecret?: string;

  /**
   * @generated from field: optional string service_url = 7;
   */
  serviceUrl?: string;

  /**
   * @generated from field: optional string worker_url = 8;
   */
  workerUrl?: string;

  /**
   * @generated from field: optional string branch_url = 13;
   */
  branchUrl?: string;

  /**
   * @generated from field: optional string kube_job_namespace = 9;
   */
  kubeJobNamespace?: string;

  /**
   * @generated from field: optional string kube_service_account_name = 10;
   */
  kubeServiceAccountName?: string;

  /**
   * @generated from field: optional chalk.server.v1.EnvironmentObjectStorageConfig environment_buckets = 11;
   */
  environmentBuckets?: EnvironmentObjectStorageConfig;

  /**
   * @generated from field: optional chalk.server.v1.DeploymentBuildProfile default_build_profile = 14;
   */
  defaultBuildProfile?: DeploymentBuildProfile;

  /**
   * @generated from field: optional string pinned_base_image = 15;
   */
  pinnedBaseImage?: string;

  /**
   * @generated from field: optional string description = 16;
   */
  description?: string;

  /**
   * @generated from field: optional string default_engine_base_image = 17;
   */
  defaultEngineBaseImage?: string;

  /**
   * @generated from field: optional string default_ai_provider_connection_id = 18;
   */
  defaultAiProviderConnectionId?: string;
};

/**
 * Describes the message chalk.server.v1.UpdateEnvironmentOperation.
 * Use `create(UpdateEnvironmentOperationSchema)` to create a new message.
 */
export const UpdateEnvironmentOperationSchema: GenMessage<UpdateEnvironmentOperation> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 23);

/**
 * @generated from message chalk.server.v1.UpdateEnvironmentRequest
 */
export type UpdateEnvironmentRequest = Message<"chalk.server.v1.UpdateEnvironmentRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: chalk.server.v1.UpdateEnvironmentOperation update = 2;
   */
  update?: UpdateEnvironmentOperation;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 3;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message chalk.server.v1.UpdateEnvironmentRequest.
 * Use `create(UpdateEnvironmentRequestSchema)` to create a new message.
 */
export const UpdateEnvironmentRequestSchema: GenMessage<UpdateEnvironmentRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 24);

/**
 * @generated from message chalk.server.v1.UpdateEnvironmentResponse
 */
export type UpdateEnvironmentResponse = Message<"chalk.server.v1.UpdateEnvironmentResponse"> & {
  /**
   * @generated from field: chalk.server.v1.Environment environment = 1;
   */
  environment?: Environment;

  /**
   * @generated from field: repeated chalk.utils.v1.FieldChange field_changes = 2;
   */
  fieldChanges: FieldChange[];
};

/**
 * Describes the message chalk.server.v1.UpdateEnvironmentResponse.
 * Use `create(UpdateEnvironmentResponseSchema)` to create a new message.
 */
export const UpdateEnvironmentResponseSchema: GenMessage<UpdateEnvironmentResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 25);

/**
 * @generated from message chalk.server.v1.GetTeamRequest
 */
export type GetTeamRequest = Message<"chalk.server.v1.GetTeamRequest"> & {
};

/**
 * Describes the message chalk.server.v1.GetTeamRequest.
 * Use `create(GetTeamRequestSchema)` to create a new message.
 */
export const GetTeamRequestSchema: GenMessage<GetTeamRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 26);

/**
 * @generated from message chalk.server.v1.GetTeamResponse
 */
export type GetTeamResponse = Message<"chalk.server.v1.GetTeamResponse"> & {
  /**
   * @generated from field: chalk.server.v1.Team team = 1;
   */
  team?: Team;
};

/**
 * Describes the message chalk.server.v1.GetTeamResponse.
 * Use `create(GetTeamResponseSchema)` to create a new message.
 */
export const GetTeamResponseSchema: GenMessage<GetTeamResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 27);

/**
 * @generated from message chalk.server.v1.CreateServiceTokenRequest
 */
export type CreateServiceTokenRequest = Message<"chalk.server.v1.CreateServiceTokenRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: repeated chalk.auth.v1.Permission permissions = 2;
   */
  permissions: Permission[];

  /**
   * @generated from field: repeated string custom_claims = 3 [deprecated = true];
   * @deprecated
   */
  customClaims: string[];

  /**
   * @generated from field: repeated chalk.auth.v1.CustomClaim customer_claims = 4;
   */
  customerClaims: CustomClaim[];

  /**
   * @generated from field: map<string, chalk.auth.v1.FeaturePermission> feature_tag_to_permission = 5;
   */
  featureTagToPermission: { [key: string]: FeaturePermission };

  /**
   * @generated from field: chalk.auth.v1.FeaturePermission default_permission = 6;
   */
  defaultPermission: FeaturePermission;

  /**
   * @generated from field: repeated chalk.auth.v1.Permission team_permissions = 7;
   */
  teamPermissions: Permission[];
};

/**
 * Describes the message chalk.server.v1.CreateServiceTokenRequest.
 * Use `create(CreateServiceTokenRequestSchema)` to create a new message.
 */
export const CreateServiceTokenRequestSchema: GenMessage<CreateServiceTokenRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 28);

/**
 * @generated from message chalk.server.v1.CreateServiceTokenResponse
 */
export type CreateServiceTokenResponse = Message<"chalk.server.v1.CreateServiceTokenResponse"> & {
  /**
   * @generated from field: chalk.auth.v1.ServiceTokenAgent agent = 1;
   */
  agent?: ServiceTokenAgent;

  /**
   * @generated from field: string client_secret = 2;
   */
  clientSecret: string;
};

/**
 * Describes the message chalk.server.v1.CreateServiceTokenResponse.
 * Use `create(CreateServiceTokenResponseSchema)` to create a new message.
 */
export const CreateServiceTokenResponseSchema: GenMessage<CreateServiceTokenResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 29);

/**
 * @generated from message chalk.server.v1.CreateServiceTokenTeamScopedRequest
 */
export type CreateServiceTokenTeamScopedRequest = Message<"chalk.server.v1.CreateServiceTokenTeamScopedRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: repeated chalk.auth.v1.Permission team_permissions = 2;
   */
  teamPermissions: Permission[];

  /**
   * @generated from field: repeated chalk.auth.v1.CustomClaim customer_claims = 3;
   */
  customerClaims: CustomClaim[];

  /**
   * @generated from field: map<string, chalk.auth.v1.FeaturePermission> feature_tag_to_permission = 4;
   */
  featureTagToPermission: { [key: string]: FeaturePermission };

  /**
   * @generated from field: chalk.auth.v1.FeaturePermission default_permission = 5;
   */
  defaultPermission: FeaturePermission;
};

/**
 * Describes the message chalk.server.v1.CreateServiceTokenTeamScopedRequest.
 * Use `create(CreateServiceTokenTeamScopedRequestSchema)` to create a new message.
 */
export const CreateServiceTokenTeamScopedRequestSchema: GenMessage<CreateServiceTokenTeamScopedRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 30);

/**
 * @generated from message chalk.server.v1.CreateServiceTokenTeamScopedResponse
 */
export type CreateServiceTokenTeamScopedResponse = Message<"chalk.server.v1.CreateServiceTokenTeamScopedResponse"> & {
  /**
   * @generated from field: chalk.auth.v1.ServiceTokenAgent agent = 1;
   */
  agent?: ServiceTokenAgent;

  /**
   * @generated from field: string client_secret = 2;
   */
  clientSecret: string;
};

/**
 * Describes the message chalk.server.v1.CreateServiceTokenTeamScopedResponse.
 * Use `create(CreateServiceTokenTeamScopedResponseSchema)` to create a new message.
 */
export const CreateServiceTokenTeamScopedResponseSchema: GenMessage<CreateServiceTokenTeamScopedResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 31);

/**
 * @generated from message chalk.server.v1.UpdateServiceTokenTeamScopedRequest
 */
export type UpdateServiceTokenTeamScopedRequest = Message<"chalk.server.v1.UpdateServiceTokenTeamScopedRequest"> & {
  /**
   * @generated from field: string client_id = 1;
   */
  clientId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: repeated chalk.auth.v1.Permission team_permissions = 3;
   */
  teamPermissions: Permission[];

  /**
   * @generated from field: repeated chalk.auth.v1.CustomClaim customer_claims = 4;
   */
  customerClaims: CustomClaim[];

  /**
   * @generated from field: map<string, chalk.auth.v1.FeaturePermission> feature_tag_to_permission = 5;
   */
  featureTagToPermission: { [key: string]: FeaturePermission };

  /**
   * @generated from field: chalk.auth.v1.FeaturePermission default_permission = 6;
   */
  defaultPermission: FeaturePermission;
};

/**
 * Describes the message chalk.server.v1.UpdateServiceTokenTeamScopedRequest.
 * Use `create(UpdateServiceTokenTeamScopedRequestSchema)` to create a new message.
 */
export const UpdateServiceTokenTeamScopedRequestSchema: GenMessage<UpdateServiceTokenTeamScopedRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 32);

/**
 * @generated from message chalk.server.v1.UpdateServiceTokenTeamScopedResponse
 */
export type UpdateServiceTokenTeamScopedResponse = Message<"chalk.server.v1.UpdateServiceTokenTeamScopedResponse"> & {
  /**
   * @generated from field: chalk.auth.v1.DisplayServiceTokenAgent agent = 1;
   */
  agent?: DisplayServiceTokenAgent;
};

/**
 * Describes the message chalk.server.v1.UpdateServiceTokenTeamScopedResponse.
 * Use `create(UpdateServiceTokenTeamScopedResponseSchema)` to create a new message.
 */
export const UpdateServiceTokenTeamScopedResponseSchema: GenMessage<UpdateServiceTokenTeamScopedResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 33);

/**
 * @generated from message chalk.server.v1.DeleteServiceTokenTeamScopedRequest
 */
export type DeleteServiceTokenTeamScopedRequest = Message<"chalk.server.v1.DeleteServiceTokenTeamScopedRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message chalk.server.v1.DeleteServiceTokenTeamScopedRequest.
 * Use `create(DeleteServiceTokenTeamScopedRequestSchema)` to create a new message.
 */
export const DeleteServiceTokenTeamScopedRequestSchema: GenMessage<DeleteServiceTokenTeamScopedRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 34);

/**
 * @generated from message chalk.server.v1.DeleteServiceTokenTeamScopedResponse
 */
export type DeleteServiceTokenTeamScopedResponse = Message<"chalk.server.v1.DeleteServiceTokenTeamScopedResponse"> & {
};

/**
 * Describes the message chalk.server.v1.DeleteServiceTokenTeamScopedResponse.
 * Use `create(DeleteServiceTokenTeamScopedResponseSchema)` to create a new message.
 */
export const DeleteServiceTokenTeamScopedResponseSchema: GenMessage<DeleteServiceTokenTeamScopedResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 35);

/**
 * @generated from message chalk.server.v1.ListServiceTokensTeamScopedRequest
 */
export type ListServiceTokensTeamScopedRequest = Message<"chalk.server.v1.ListServiceTokensTeamScopedRequest"> & {
};

/**
 * Describes the message chalk.server.v1.ListServiceTokensTeamScopedRequest.
 * Use `create(ListServiceTokensTeamScopedRequestSchema)` to create a new message.
 */
export const ListServiceTokensTeamScopedRequestSchema: GenMessage<ListServiceTokensTeamScopedRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 36);

/**
 * @generated from message chalk.server.v1.ListServiceTokensTeamScopedResponse
 */
export type ListServiceTokensTeamScopedResponse = Message<"chalk.server.v1.ListServiceTokensTeamScopedResponse"> & {
  /**
   * @generated from field: repeated chalk.auth.v1.DisplayServiceTokenAgent agents = 1;
   */
  agents: DisplayServiceTokenAgent[];
};

/**
 * Describes the message chalk.server.v1.ListServiceTokensTeamScopedResponse.
 * Use `create(ListServiceTokensTeamScopedResponseSchema)` to create a new message.
 */
export const ListServiceTokensTeamScopedResponseSchema: GenMessage<ListServiceTokensTeamScopedResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 37);

/**
 * @generated from message chalk.server.v1.DeleteServiceTokenRequest
 */
export type DeleteServiceTokenRequest = Message<"chalk.server.v1.DeleteServiceTokenRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message chalk.server.v1.DeleteServiceTokenRequest.
 * Use `create(DeleteServiceTokenRequestSchema)` to create a new message.
 */
export const DeleteServiceTokenRequestSchema: GenMessage<DeleteServiceTokenRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 38);

/**
 * @generated from message chalk.server.v1.DeleteServiceTokenResponse
 */
export type DeleteServiceTokenResponse = Message<"chalk.server.v1.DeleteServiceTokenResponse"> & {
};

/**
 * Describes the message chalk.server.v1.DeleteServiceTokenResponse.
 * Use `create(DeleteServiceTokenResponseSchema)` to create a new message.
 */
export const DeleteServiceTokenResponseSchema: GenMessage<DeleteServiceTokenResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 39);

/**
 * @generated from message chalk.server.v1.PermissionDescription
 */
export type PermissionDescription = Message<"chalk.server.v1.PermissionDescription"> & {
  /**
   * @generated from field: chalk.auth.v1.Permission id = 1;
   */
  id: Permission;

  /**
   * @generated from field: string slug = 2;
   */
  slug: string;

  /**
   * @generated from field: string namespace = 3;
   */
  namespace: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * @generated from field: string group_description = 6;
   */
  groupDescription: string;
};

/**
 * Describes the message chalk.server.v1.PermissionDescription.
 * Use `create(PermissionDescriptionSchema)` to create a new message.
 */
export const PermissionDescriptionSchema: GenMessage<PermissionDescription> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 40);

/**
 * @generated from message chalk.server.v1.RoleDescription
 */
export type RoleDescription = Message<"chalk.server.v1.RoleDescription"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: repeated chalk.auth.v1.Permission permissions = 4;
   */
  permissions: Permission[];

  /**
   * @generated from field: chalk.auth.v1.FeaturePermissions feature_permissions = 5;
   */
  featurePermissions?: FeaturePermissions;

  /**
   * @generated from field: bool is_default = 6;
   */
  isDefault: boolean;
};

/**
 * Describes the message chalk.server.v1.RoleDescription.
 * Use `create(RoleDescriptionSchema)` to create a new message.
 */
export const RoleDescriptionSchema: GenMessage<RoleDescription> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 41);

/**
 * @generated from message chalk.server.v1.GetAvailablePermissionsRequest
 */
export type GetAvailablePermissionsRequest = Message<"chalk.server.v1.GetAvailablePermissionsRequest"> & {
};

/**
 * Describes the message chalk.server.v1.GetAvailablePermissionsRequest.
 * Use `create(GetAvailablePermissionsRequestSchema)` to create a new message.
 */
export const GetAvailablePermissionsRequestSchema: GenMessage<GetAvailablePermissionsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 42);

/**
 * @generated from message chalk.server.v1.GetAvailablePermissionsResponse
 */
export type GetAvailablePermissionsResponse = Message<"chalk.server.v1.GetAvailablePermissionsResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.PermissionDescription permissions = 1;
   */
  permissions: PermissionDescription[];

  /**
   * @generated from field: repeated chalk.server.v1.RoleDescription roles = 2;
   */
  roles: RoleDescription[];

  /**
   * @generated from field: repeated chalk.auth.v1.Permission available_service_token_permissions = 3;
   */
  availableServiceTokenPermissions: Permission[];
};

/**
 * Describes the message chalk.server.v1.GetAvailablePermissionsResponse.
 * Use `create(GetAvailablePermissionsResponseSchema)` to create a new message.
 */
export const GetAvailablePermissionsResponseSchema: GenMessage<GetAvailablePermissionsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 43);

/**
 * @generated from message chalk.server.v1.UpsertFeaturePermissionsRequest
 */
export type UpsertFeaturePermissionsRequest = Message<"chalk.server.v1.UpsertFeaturePermissionsRequest"> & {
  /**
   * @generated from field: string role = 1;
   */
  role: string;

  /**
   * @generated from field: chalk.auth.v1.FeaturePermissions permissions = 2;
   */
  permissions?: FeaturePermissions;
};

/**
 * Describes the message chalk.server.v1.UpsertFeaturePermissionsRequest.
 * Use `create(UpsertFeaturePermissionsRequestSchema)` to create a new message.
 */
export const UpsertFeaturePermissionsRequestSchema: GenMessage<UpsertFeaturePermissionsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 44);

/**
 * @generated from message chalk.server.v1.UpsertFeaturePermissionsResponse
 */
export type UpsertFeaturePermissionsResponse = Message<"chalk.server.v1.UpsertFeaturePermissionsResponse"> & {
  /**
   * @generated from field: string role = 1;
   */
  role: string;

  /**
   * @generated from field: chalk.auth.v1.FeaturePermissions permissions = 2;
   */
  permissions?: FeaturePermissions;
};

/**
 * Describes the message chalk.server.v1.UpsertFeaturePermissionsResponse.
 * Use `create(UpsertFeaturePermissionsResponseSchema)` to create a new message.
 */
export const UpsertFeaturePermissionsResponseSchema: GenMessage<UpsertFeaturePermissionsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 45);

/**
 * @generated from message chalk.server.v1.ListServiceTokensRequest
 */
export type ListServiceTokensRequest = Message<"chalk.server.v1.ListServiceTokensRequest"> & {
};

/**
 * Describes the message chalk.server.v1.ListServiceTokensRequest.
 * Use `create(ListServiceTokensRequestSchema)` to create a new message.
 */
export const ListServiceTokensRequestSchema: GenMessage<ListServiceTokensRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 46);

/**
 * @generated from message chalk.server.v1.ListServiceTokensResponse
 */
export type ListServiceTokensResponse = Message<"chalk.server.v1.ListServiceTokensResponse"> & {
  /**
   * @generated from field: repeated chalk.auth.v1.DisplayServiceTokenAgent agents = 1;
   */
  agents: DisplayServiceTokenAgent[];
};

/**
 * Describes the message chalk.server.v1.ListServiceTokensResponse.
 * Use `create(ListServiceTokensResponseSchema)` to create a new message.
 */
export const ListServiceTokensResponseSchema: GenMessage<ListServiceTokensResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 47);

/**
 * @generated from message chalk.server.v1.UpdateServiceTokenRequest
 */
export type UpdateServiceTokenRequest = Message<"chalk.server.v1.UpdateServiceTokenRequest"> & {
  /**
   * @generated from field: string client_id = 1;
   */
  clientId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: repeated chalk.auth.v1.Permission permissions = 3;
   */
  permissions: Permission[];

  /**
   * @generated from field: repeated chalk.auth.v1.CustomClaim customer_claims = 4;
   */
  customerClaims: CustomClaim[];

  /**
   * @generated from field: map<string, chalk.auth.v1.FeaturePermission> feature_tag_to_permission = 5;
   */
  featureTagToPermission: { [key: string]: FeaturePermission };

  /**
   * @generated from field: chalk.auth.v1.FeaturePermission default_permission = 6;
   */
  defaultPermission: FeaturePermission;

  /**
   * @generated from field: repeated chalk.auth.v1.Permission team_permissions = 7;
   */
  teamPermissions: Permission[];
};

/**
 * Describes the message chalk.server.v1.UpdateServiceTokenRequest.
 * Use `create(UpdateServiceTokenRequestSchema)` to create a new message.
 */
export const UpdateServiceTokenRequestSchema: GenMessage<UpdateServiceTokenRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 48);

/**
 * @generated from message chalk.server.v1.UpdateServiceTokenResponse
 */
export type UpdateServiceTokenResponse = Message<"chalk.server.v1.UpdateServiceTokenResponse"> & {
  /**
   * @generated from field: chalk.auth.v1.DisplayServiceTokenAgent agent = 1;
   */
  agent?: DisplayServiceTokenAgent;
};

/**
 * Describes the message chalk.server.v1.UpdateServiceTokenResponse.
 * Use `create(UpdateServiceTokenResponseSchema)` to create a new message.
 */
export const UpdateServiceTokenResponseSchema: GenMessage<UpdateServiceTokenResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 49);

/**
 * @generated from message chalk.server.v1.UpdateScimGroupSettingsRequest
 */
export type UpdateScimGroupSettingsRequest = Message<"chalk.server.v1.UpdateScimGroupSettingsRequest"> & {
  /**
   * @generated from field: repeated string query_tags = 1;
   */
  queryTags: string[];

  /**
   * @generated from field: string group = 2;
   */
  group: string;
};

/**
 * Describes the message chalk.server.v1.UpdateScimGroupSettingsRequest.
 * Use `create(UpdateScimGroupSettingsRequestSchema)` to create a new message.
 */
export const UpdateScimGroupSettingsRequestSchema: GenMessage<UpdateScimGroupSettingsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 50);

/**
 * @generated from message chalk.server.v1.UpdateScimGroupSettingsResponse
 */
export type UpdateScimGroupSettingsResponse = Message<"chalk.server.v1.UpdateScimGroupSettingsResponse"> & {
  /**
   * @generated from field: repeated string query_tags = 1;
   */
  queryTags: string[];
};

/**
 * Describes the message chalk.server.v1.UpdateScimGroupSettingsResponse.
 * Use `create(UpdateScimGroupSettingsResponseSchema)` to create a new message.
 */
export const UpdateScimGroupSettingsResponseSchema: GenMessage<UpdateScimGroupSettingsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 51);

/**
 * @generated from message chalk.server.v1.InviteTeamMemberRequest
 */
export type InviteTeamMemberRequest = Message<"chalk.server.v1.InviteTeamMemberRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: optional string role_id = 2;
   */
  roleId?: string;
};

/**
 * Describes the message chalk.server.v1.InviteTeamMemberRequest.
 * Use `create(InviteTeamMemberRequestSchema)` to create a new message.
 */
export const InviteTeamMemberRequestSchema: GenMessage<InviteTeamMemberRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 52);

/**
 * @generated from message chalk.server.v1.InviteTeamMemberResponse
 */
export type InviteTeamMemberResponse = Message<"chalk.server.v1.InviteTeamMemberResponse"> & {
};

/**
 * Describes the message chalk.server.v1.InviteTeamMemberResponse.
 * Use `create(InviteTeamMemberResponseSchema)` to create a new message.
 */
export const InviteTeamMemberResponseSchema: GenMessage<InviteTeamMemberResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 53);

/**
 * @generated from message chalk.server.v1.InviteTeamMemberWithTeamRoleRequest
 */
export type InviteTeamMemberWithTeamRoleRequest = Message<"chalk.server.v1.InviteTeamMemberWithTeamRoleRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: optional string team_role_id = 2;
   */
  teamRoleId?: string;
};

/**
 * Describes the message chalk.server.v1.InviteTeamMemberWithTeamRoleRequest.
 * Use `create(InviteTeamMemberWithTeamRoleRequestSchema)` to create a new message.
 */
export const InviteTeamMemberWithTeamRoleRequestSchema: GenMessage<InviteTeamMemberWithTeamRoleRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 54);

/**
 * @generated from message chalk.server.v1.InviteTeamMemberWithTeamRoleResponse
 */
export type InviteTeamMemberWithTeamRoleResponse = Message<"chalk.server.v1.InviteTeamMemberWithTeamRoleResponse"> & {
};

/**
 * Describes the message chalk.server.v1.InviteTeamMemberWithTeamRoleResponse.
 * Use `create(InviteTeamMemberWithTeamRoleResponseSchema)` to create a new message.
 */
export const InviteTeamMemberWithTeamRoleResponseSchema: GenMessage<InviteTeamMemberWithTeamRoleResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 55);

/**
 * @generated from message chalk.server.v1.ExpireTeamInviteRequest
 */
export type ExpireTeamInviteRequest = Message<"chalk.server.v1.ExpireTeamInviteRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message chalk.server.v1.ExpireTeamInviteRequest.
 * Use `create(ExpireTeamInviteRequestSchema)` to create a new message.
 */
export const ExpireTeamInviteRequestSchema: GenMessage<ExpireTeamInviteRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 56);

/**
 * @generated from message chalk.server.v1.ExpireTeamInviteResponse
 */
export type ExpireTeamInviteResponse = Message<"chalk.server.v1.ExpireTeamInviteResponse"> & {
};

/**
 * Describes the message chalk.server.v1.ExpireTeamInviteResponse.
 * Use `create(ExpireTeamInviteResponseSchema)` to create a new message.
 */
export const ExpireTeamInviteResponseSchema: GenMessage<ExpireTeamInviteResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 57);

/**
 * @generated from message chalk.server.v1.TeamInvite
 */
export type TeamInvite = Message<"chalk.server.v1.TeamInvite"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: string team = 3;
   */
  team: string;

  /**
   * @generated from field: optional string role = 4;
   */
  role?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional string role_id_scope = 9;
   */
  roleIdScope?: string;
};

/**
 * Describes the message chalk.server.v1.TeamInvite.
 * Use `create(TeamInviteSchema)` to create a new message.
 */
export const TeamInviteSchema: GenMessage<TeamInvite> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 58);

/**
 * @generated from message chalk.server.v1.ListTeamInvitesRequest
 */
export type ListTeamInvitesRequest = Message<"chalk.server.v1.ListTeamInvitesRequest"> & {
};

/**
 * Describes the message chalk.server.v1.ListTeamInvitesRequest.
 * Use `create(ListTeamInvitesRequestSchema)` to create a new message.
 */
export const ListTeamInvitesRequestSchema: GenMessage<ListTeamInvitesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 59);

/**
 * @generated from message chalk.server.v1.ListTeamInvitesResponse
 */
export type ListTeamInvitesResponse = Message<"chalk.server.v1.ListTeamInvitesResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.TeamInvite invites = 1;
   */
  invites: TeamInvite[];
};

/**
 * Describes the message chalk.server.v1.ListTeamInvitesResponse.
 * Use `create(ListTeamInvitesResponseSchema)` to create a new message.
 */
export const ListTeamInvitesResponseSchema: GenMessage<ListTeamInvitesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 60);

/**
 * @generated from message chalk.server.v1.ScimGroup
 */
export type ScimGroup = Message<"chalk.server.v1.ScimGroup"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string display = 2;
   */
  display: string;

  /**
   * @generated from field: string team_id = 3;
   */
  teamId: string;

  /**
   * @generated from field: repeated string members = 4;
   */
  members: string[];
};

/**
 * Describes the message chalk.server.v1.ScimGroup.
 * Use `create(ScimGroupSchema)` to create a new message.
 */
export const ScimGroupSchema: GenMessage<ScimGroup> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 61);

/**
 * @generated from message chalk.server.v1.ScimGroupRoleAssignment
 */
export type ScimGroupRoleAssignment = Message<"chalk.server.v1.ScimGroupRoleAssignment"> & {
  /**
   * @generated from field: string group_id = 1;
   */
  groupId: string;

  /**
   * @generated from field: string environment_id = 3;
   */
  environmentId: string;

  /**
   * @generated from field: string role_id = 4;
   */
  roleId: string;

  /**
   * @generated from field: repeated string query_tags = 5;
   */
  queryTags: string[];
};

/**
 * Describes the message chalk.server.v1.ScimGroupRoleAssignment.
 * Use `create(ScimGroupRoleAssignmentSchema)` to create a new message.
 */
export const ScimGroupRoleAssignmentSchema: GenMessage<ScimGroupRoleAssignment> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 62);

/**
 * @generated from message chalk.server.v1.UserRoleAssignment
 */
export type UserRoleAssignment = Message<"chalk.server.v1.UserRoleAssignment"> & {
  /**
   * @generated from field: string role_id = 1;
   */
  roleId: string;

  /**
   * @generated from field: string type = 2;
   */
  type: string;
};

/**
 * Describes the message chalk.server.v1.UserRoleAssignment.
 * Use `create(UserRoleAssignmentSchema)` to create a new message.
 */
export const UserRoleAssignmentSchema: GenMessage<UserRoleAssignment> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 63);

/**
 * @generated from message chalk.server.v1.UserPermissions
 */
export type UserPermissions = Message<"chalk.server.v1.UserPermissions"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string environment_id = 2;
   */
  environmentId: string;

  /**
   * @generated from field: repeated chalk.server.v1.UserRoleAssignment user_roles = 3;
   */
  userRoles: UserRoleAssignment[];

  /**
   * @generated from field: repeated chalk.auth.v1.Permission user_permissions = 4;
   */
  userPermissions: Permission[];
};

/**
 * Describes the message chalk.server.v1.UserPermissions.
 * Use `create(UserPermissionsSchema)` to create a new message.
 */
export const UserPermissionsSchema: GenMessage<UserPermissions> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 64);

/**
 * @generated from message chalk.server.v1.UserTeamPermissions
 */
export type UserTeamPermissions = Message<"chalk.server.v1.UserTeamPermissions"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: repeated chalk.server.v1.UserRoleAssignment user_roles = 2;
   */
  userRoles: UserRoleAssignment[];

  /**
   * @generated from field: repeated chalk.auth.v1.Permission user_permissions = 3;
   */
  userPermissions: Permission[];
};

/**
 * Describes the message chalk.server.v1.UserTeamPermissions.
 * Use `create(UserTeamPermissionsSchema)` to create a new message.
 */
export const UserTeamPermissionsSchema: GenMessage<UserTeamPermissions> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 65);

/**
 * @generated from message chalk.server.v1.User
 */
export type User = Message<"chalk.server.v1.User"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * @generated from field: optional string email = 3;
   */
  email?: string;

  /**
   * @generated from field: optional string image = 4;
   */
  image?: string;

  /**
   * @generated from field: optional string team_id = 5;
   */
  teamId?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp deactivated_at = 6;
   */
  deactivatedAt?: Timestamp;
};

/**
 * Describes the message chalk.server.v1.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 66);

/**
 * @generated from message chalk.server.v1.ListTeamMembersPageToken
 */
export type ListTeamMembersPageToken = Message<"chalk.server.v1.ListTeamMembersPageToken"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * Describes the message chalk.server.v1.ListTeamMembersPageToken.
 * Use `create(ListTeamMembersPageTokenSchema)` to create a new message.
 */
export const ListTeamMembersPageTokenSchema: GenMessage<ListTeamMembersPageToken> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 67);

/**
 * @generated from message chalk.server.v1.ListTeamMembersFilters
 */
export type ListTeamMembersFilters = Message<"chalk.server.v1.ListTeamMembersFilters"> & {
  /**
   * @generated from field: optional bool include_deactivated = 1;
   */
  includeDeactivated?: boolean;
};

/**
 * Describes the message chalk.server.v1.ListTeamMembersFilters.
 * Use `create(ListTeamMembersFiltersSchema)` to create a new message.
 */
export const ListTeamMembersFiltersSchema: GenMessage<ListTeamMembersFilters> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 68);

/**
 * @generated from message chalk.server.v1.ListTeamMembersRequest
 */
export type ListTeamMembersRequest = Message<"chalk.server.v1.ListTeamMembersRequest"> & {
  /**
   * @generated from field: optional int32 limit = 1;
   */
  limit?: number;

  /**
   * @generated from field: optional string page_token = 2;
   */
  pageToken?: string;

  /**
   * @generated from field: optional chalk.server.v1.ListTeamMembersFilters filters = 3;
   */
  filters?: ListTeamMembersFilters;
};

/**
 * Describes the message chalk.server.v1.ListTeamMembersRequest.
 * Use `create(ListTeamMembersRequestSchema)` to create a new message.
 */
export const ListTeamMembersRequestSchema: GenMessage<ListTeamMembersRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 69);

/**
 * @generated from message chalk.server.v1.ListTeamMembersResponse
 */
export type ListTeamMembersResponse = Message<"chalk.server.v1.ListTeamMembersResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.User members = 1;
   */
  members: User[];

  /**
   * @generated from field: optional string next_page_token = 2;
   */
  nextPageToken?: string;
};

/**
 * Describes the message chalk.server.v1.ListTeamMembersResponse.
 * Use `create(ListTeamMembersResponseSchema)` to create a new message.
 */
export const ListTeamMembersResponseSchema: GenMessage<ListTeamMembersResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 70);

/**
 * @generated from message chalk.server.v1.EnvironmentPermissions
 */
export type EnvironmentPermissions = Message<"chalk.server.v1.EnvironmentPermissions"> & {
  /**
   * @generated from field: string environment_id = 1;
   */
  environmentId: string;

  /**
   * @generated from field: repeated chalk.server.v1.ScimGroupRoleAssignment scim_roles = 2;
   */
  scimRoles: ScimGroupRoleAssignment[];

  /**
   * @generated from field: repeated chalk.server.v1.UserPermissions user_permissions = 3;
   */
  userPermissions: UserPermissions[];
};

/**
 * Describes the message chalk.server.v1.EnvironmentPermissions.
 * Use `create(EnvironmentPermissionsSchema)` to create a new message.
 */
export const EnvironmentPermissionsSchema: GenMessage<EnvironmentPermissions> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 71);

/**
 * @generated from message chalk.server.v1.TeamPermissions
 */
export type TeamPermissions = Message<"chalk.server.v1.TeamPermissions"> & {
  /**
   * @generated from field: repeated chalk.server.v1.UserTeamPermissions user_team_permissions = 1;
   */
  userTeamPermissions: UserTeamPermissions[];
};

/**
 * Describes the message chalk.server.v1.TeamPermissions.
 * Use `create(TeamPermissionsSchema)` to create a new message.
 */
export const TeamPermissionsSchema: GenMessage<TeamPermissions> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 72);

/**
 * @generated from message chalk.server.v1.GetTeamPermissionsRequest
 */
export type GetTeamPermissionsRequest = Message<"chalk.server.v1.GetTeamPermissionsRequest"> & {
};

/**
 * Describes the message chalk.server.v1.GetTeamPermissionsRequest.
 * Use `create(GetTeamPermissionsRequestSchema)` to create a new message.
 */
export const GetTeamPermissionsRequestSchema: GenMessage<GetTeamPermissionsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 73);

/**
 * @generated from message chalk.server.v1.GetTeamPermissionsResponse
 */
export type GetTeamPermissionsResponse = Message<"chalk.server.v1.GetTeamPermissionsResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.RoleDescription roles = 1;
   */
  roles: RoleDescription[];

  /**
   * @generated from field: repeated chalk.server.v1.ScimGroup scim_groups = 2;
   */
  scimGroups: ScimGroup[];

  /**
   * @generated from field: repeated chalk.server.v1.EnvironmentPermissions environment_permissions = 3;
   */
  environmentPermissions: EnvironmentPermissions[];

  /**
   * @generated from field: repeated chalk.server.v1.User team_members = 4;
   */
  teamMembers: User[];

  /**
   * @generated from field: optional chalk.server.v1.TeamPermissions team_permissions = 5;
   */
  teamPermissions?: TeamPermissions;
};

/**
 * Describes the message chalk.server.v1.GetTeamPermissionsResponse.
 * Use `create(GetTeamPermissionsResponseSchema)` to create a new message.
 */
export const GetTeamPermissionsResponseSchema: GenMessage<GetTeamPermissionsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 74);

/**
 * @generated from message chalk.server.v1.ArchiveEnvironmentRequest
 */
export type ArchiveEnvironmentRequest = Message<"chalk.server.v1.ArchiveEnvironmentRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message chalk.server.v1.ArchiveEnvironmentRequest.
 * Use `create(ArchiveEnvironmentRequestSchema)` to create a new message.
 */
export const ArchiveEnvironmentRequestSchema: GenMessage<ArchiveEnvironmentRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 75);

/**
 * @generated from message chalk.server.v1.ArchiveEnvironmentResponse
 */
export type ArchiveEnvironmentResponse = Message<"chalk.server.v1.ArchiveEnvironmentResponse"> & {
};

/**
 * Describes the message chalk.server.v1.ArchiveEnvironmentResponse.
 * Use `create(ArchiveEnvironmentResponseSchema)` to create a new message.
 */
export const ArchiveEnvironmentResponseSchema: GenMessage<ArchiveEnvironmentResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 76);

/**
 * Clears out a team created by the self-signup flow so the email addresses of its
 * members are free to sign up again. Deactivating a user does not achieve that --
 * the "User" row keeps the address, and the signup flow refuses it -- so this
 * deletes the rows outright. It exists to reset the state left behind by testing
 * the signup flow, and is Chalk-employee-only.
 *
 * @generated from message chalk.server.v1.DeleteSelfSignupTeamRequest
 */
export type DeleteSelfSignupTeamRequest = Message<"chalk.server.v1.DeleteSelfSignupTeamRequest"> & {
  /**
   * The team to clear out. It is a confirmation, not a selector: the operation
   * always applies to the team the caller is acting as (their own, or the one
   * they are impersonating), and a value that does not match that team is
   * rejected. Requiring it means an admin who left an impersonation session
   * pointed at the wrong team destroys nothing.
   *
   * @generated from field: string team_id = 1;
   */
  teamId: string;
};

/**
 * Describes the message chalk.server.v1.DeleteSelfSignupTeamRequest.
 * Use `create(DeleteSelfSignupTeamRequestSchema)` to create a new message.
 */
export const DeleteSelfSignupTeamRequestSchema: GenMessage<DeleteSelfSignupTeamRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 77);

/**
 * @generated from message chalk.server.v1.DeleteSelfSignupTeamResponse
 */
export type DeleteSelfSignupTeamResponse = Message<"chalk.server.v1.DeleteSelfSignupTeamResponse"> & {
  /**
   * @generated from field: repeated string archived_environment_ids = 1;
   */
  archivedEnvironmentIds: string[];

  /**
   * @generated from field: repeated string archived_project_ids = 2;
   */
  archivedProjectIds: string[];

  /**
   * @generated from field: int64 deleted_user_count = 3;
   */
  deletedUserCount: bigint;

  /**
   * @generated from field: int64 deleted_role_assignment_count = 4;
   */
  deletedRoleAssignmentCount: bigint;
};

/**
 * Describes the message chalk.server.v1.DeleteSelfSignupTeamResponse.
 * Use `create(DeleteSelfSignupTeamResponseSchema)` to create a new message.
 */
export const DeleteSelfSignupTeamResponseSchema: GenMessage<DeleteSelfSignupTeamResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 78);

/**
 * @generated from message chalk.server.v1.DeactivateUserRequest
 */
export type DeactivateUserRequest = Message<"chalk.server.v1.DeactivateUserRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * Describes the message chalk.server.v1.DeactivateUserRequest.
 * Use `create(DeactivateUserRequestSchema)` to create a new message.
 */
export const DeactivateUserRequestSchema: GenMessage<DeactivateUserRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 79);

/**
 * @generated from message chalk.server.v1.DeactivateUserResponse
 */
export type DeactivateUserResponse = Message<"chalk.server.v1.DeactivateUserResponse"> & {
};

/**
 * Describes the message chalk.server.v1.DeactivateUserResponse.
 * Use `create(DeactivateUserResponseSchema)` to create a new message.
 */
export const DeactivateUserResponseSchema: GenMessage<DeactivateUserResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 80);

/**
 * @generated from message chalk.server.v1.ReactivateUserRequest
 */
export type ReactivateUserRequest = Message<"chalk.server.v1.ReactivateUserRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * Describes the message chalk.server.v1.ReactivateUserRequest.
 * Use `create(ReactivateUserRequestSchema)` to create a new message.
 */
export const ReactivateUserRequestSchema: GenMessage<ReactivateUserRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 81);

/**
 * @generated from message chalk.server.v1.ReactivateUserResponse
 */
export type ReactivateUserResponse = Message<"chalk.server.v1.ReactivateUserResponse"> & {
};

/**
 * Describes the message chalk.server.v1.ReactivateUserResponse.
 * Use `create(ReactivateUserResponseSchema)` to create a new message.
 */
export const ReactivateUserResponseSchema: GenMessage<ReactivateUserResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 82);

/**
 * @generated from message chalk.server.v1.AssignTeamRoleRequest
 */
export type AssignTeamRoleRequest = Message<"chalk.server.v1.AssignTeamRoleRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string role_id = 2;
   */
  roleId: string;
};

/**
 * Describes the message chalk.server.v1.AssignTeamRoleRequest.
 * Use `create(AssignTeamRoleRequestSchema)` to create a new message.
 */
export const AssignTeamRoleRequestSchema: GenMessage<AssignTeamRoleRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 83);

/**
 * @generated from message chalk.server.v1.AssignTeamRoleResponse
 */
export type AssignTeamRoleResponse = Message<"chalk.server.v1.AssignTeamRoleResponse"> & {
};

/**
 * Describes the message chalk.server.v1.AssignTeamRoleResponse.
 * Use `create(AssignTeamRoleResponseSchema)` to create a new message.
 */
export const AssignTeamRoleResponseSchema: GenMessage<AssignTeamRoleResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 84);

/**
 * @generated from message chalk.server.v1.AssignEnvironmentRoleRequest
 */
export type AssignEnvironmentRoleRequest = Message<"chalk.server.v1.AssignEnvironmentRoleRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string role_id = 2;
   */
  roleId: string;
};

/**
 * Describes the message chalk.server.v1.AssignEnvironmentRoleRequest.
 * Use `create(AssignEnvironmentRoleRequestSchema)` to create a new message.
 */
export const AssignEnvironmentRoleRequestSchema: GenMessage<AssignEnvironmentRoleRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 85);

/**
 * @generated from message chalk.server.v1.AssignEnvironmentRoleResponse
 */
export type AssignEnvironmentRoleResponse = Message<"chalk.server.v1.AssignEnvironmentRoleResponse"> & {
};

/**
 * Describes the message chalk.server.v1.AssignEnvironmentRoleResponse.
 * Use `create(AssignEnvironmentRoleResponseSchema)` to create a new message.
 */
export const AssignEnvironmentRoleResponseSchema: GenMessage<AssignEnvironmentRoleResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 86);

/**
 * @generated from message chalk.server.v1.AssignScimGroupEnvironmentRoleRequest
 */
export type AssignScimGroupEnvironmentRoleRequest = Message<"chalk.server.v1.AssignScimGroupEnvironmentRoleRequest"> & {
  /**
   * @generated from field: string group_id = 1;
   */
  groupId: string;

  /**
   * @generated from field: string role_id = 2;
   */
  roleId: string;
};

/**
 * Describes the message chalk.server.v1.AssignScimGroupEnvironmentRoleRequest.
 * Use `create(AssignScimGroupEnvironmentRoleRequestSchema)` to create a new message.
 */
export const AssignScimGroupEnvironmentRoleRequestSchema: GenMessage<AssignScimGroupEnvironmentRoleRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 87);

/**
 * @generated from message chalk.server.v1.AssignScimGroupEnvironmentRoleResponse
 */
export type AssignScimGroupEnvironmentRoleResponse = Message<"chalk.server.v1.AssignScimGroupEnvironmentRoleResponse"> & {
};

/**
 * Describes the message chalk.server.v1.AssignScimGroupEnvironmentRoleResponse.
 * Use `create(AssignScimGroupEnvironmentRoleResponseSchema)` to create a new message.
 */
export const AssignScimGroupEnvironmentRoleResponseSchema: GenMessage<AssignScimGroupEnvironmentRoleResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 88);

/**
 * @generated from message chalk.server.v1.DeleteScimGroupRequest
 */
export type DeleteScimGroupRequest = Message<"chalk.server.v1.DeleteScimGroupRequest"> & {
  /**
   * @generated from field: string group_id = 1;
   */
  groupId: string;
};

/**
 * Describes the message chalk.server.v1.DeleteScimGroupRequest.
 * Use `create(DeleteScimGroupRequestSchema)` to create a new message.
 */
export const DeleteScimGroupRequestSchema: GenMessage<DeleteScimGroupRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 89);

/**
 * @generated from message chalk.server.v1.DeleteScimGroupResponse
 */
export type DeleteScimGroupResponse = Message<"chalk.server.v1.DeleteScimGroupResponse"> & {
};

/**
 * Describes the message chalk.server.v1.DeleteScimGroupResponse.
 * Use `create(DeleteScimGroupResponseSchema)` to create a new message.
 */
export const DeleteScimGroupResponseSchema: GenMessage<DeleteScimGroupResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 90);

/**
 * @generated from message chalk.server.v1.DeleteScimGroupUsersRequest
 */
export type DeleteScimGroupUsersRequest = Message<"chalk.server.v1.DeleteScimGroupUsersRequest"> & {
  /**
   * @generated from field: string group_id = 1;
   */
  groupId: string;
};

/**
 * Describes the message chalk.server.v1.DeleteScimGroupUsersRequest.
 * Use `create(DeleteScimGroupUsersRequestSchema)` to create a new message.
 */
export const DeleteScimGroupUsersRequestSchema: GenMessage<DeleteScimGroupUsersRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 91);

/**
 * @generated from message chalk.server.v1.DeleteScimGroupUsersResponse
 */
export type DeleteScimGroupUsersResponse = Message<"chalk.server.v1.DeleteScimGroupUsersResponse"> & {
  /**
   * @generated from field: chalk.server.v1.ScimGroup scim_group = 1;
   */
  scimGroup?: ScimGroup;
};

/**
 * Describes the message chalk.server.v1.DeleteScimGroupUsersResponse.
 * Use `create(DeleteScimGroupUsersResponseSchema)` to create a new message.
 */
export const DeleteScimGroupUsersResponseSchema: GenMessage<DeleteScimGroupUsersResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 92);

/**
 * @generated from message chalk.server.v1.CreateVectorDBConfigurationRequest
 */
export type CreateVectorDBConfigurationRequest = Message<"chalk.server.v1.CreateVectorDBConfigurationRequest"> & {
  /**
   * The environment ID to configure
   *
   * @generated from field: string environment_id = 1;
   */
  environmentId: string;

  /**
   * The URI to the vector database (will be stored as a secret)
   *
   * @generated from field: string vector_db_uri = 2;
   */
  vectorDbUri: string;

  /**
   * The kind/type of vector database
   *
   * @generated from field: chalk.server.v1.VectorDBKind vector_db_kind = 3;
   */
  vectorDbKind: VectorDBKind;
};

/**
 * Describes the message chalk.server.v1.CreateVectorDBConfigurationRequest.
 * Use `create(CreateVectorDBConfigurationRequestSchema)` to create a new message.
 */
export const CreateVectorDBConfigurationRequestSchema: GenMessage<CreateVectorDBConfigurationRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 93);

/**
 * @generated from message chalk.server.v1.CreateVectorDBConfigurationResponse
 */
export type CreateVectorDBConfigurationResponse = Message<"chalk.server.v1.CreateVectorDBConfigurationResponse"> & {
  /**
   * @generated from field: chalk.server.v1.Environment environment = 1;
   */
  environment?: Environment;
};

/**
 * Describes the message chalk.server.v1.CreateVectorDBConfigurationResponse.
 * Use `create(CreateVectorDBConfigurationResponseSchema)` to create a new message.
 */
export const CreateVectorDBConfigurationResponseSchema: GenMessage<CreateVectorDBConfigurationResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 94);

/**
 * @generated from message chalk.server.v1.CreateCustomRoleRequest
 */
export type CreateCustomRoleRequest = Message<"chalk.server.v1.CreateCustomRoleRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: repeated chalk.auth.v1.Permission permissions = 3;
   */
  permissions: Permission[];
};

/**
 * Describes the message chalk.server.v1.CreateCustomRoleRequest.
 * Use `create(CreateCustomRoleRequestSchema)` to create a new message.
 */
export const CreateCustomRoleRequestSchema: GenMessage<CreateCustomRoleRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 95);

/**
 * @generated from message chalk.server.v1.CreateCustomRoleResponse
 */
export type CreateCustomRoleResponse = Message<"chalk.server.v1.CreateCustomRoleResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: repeated string permissions = 4;
   */
  permissions: string[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message chalk.server.v1.CreateCustomRoleResponse.
 * Use `create(CreateCustomRoleResponseSchema)` to create a new message.
 */
export const CreateCustomRoleResponseSchema: GenMessage<CreateCustomRoleResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 96);

/**
 * @generated from message chalk.server.v1.DeleteCustomRoleRequest
 */
export type DeleteCustomRoleRequest = Message<"chalk.server.v1.DeleteCustomRoleRequest"> & {
  /**
   * @generated from field: string role_id = 1;
   */
  roleId: string;
};

/**
 * Describes the message chalk.server.v1.DeleteCustomRoleRequest.
 * Use `create(DeleteCustomRoleRequestSchema)` to create a new message.
 */
export const DeleteCustomRoleRequestSchema: GenMessage<DeleteCustomRoleRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 97);

/**
 * @generated from message chalk.server.v1.DeleteCustomRoleResponse
 */
export type DeleteCustomRoleResponse = Message<"chalk.server.v1.DeleteCustomRoleResponse"> & {
};

/**
 * Describes the message chalk.server.v1.DeleteCustomRoleResponse.
 * Use `create(DeleteCustomRoleResponseSchema)` to create a new message.
 */
export const DeleteCustomRoleResponseSchema: GenMessage<DeleteCustomRoleResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 98);

/**
 * @generated from message chalk.server.v1.UpdateCustomRoleRequest
 */
export type UpdateCustomRoleRequest = Message<"chalk.server.v1.UpdateCustomRoleRequest"> & {
  /**
   * @generated from field: string role_id = 1;
   */
  roleId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: repeated chalk.auth.v1.Permission permissions = 4;
   */
  permissions: Permission[];
};

/**
 * Describes the message chalk.server.v1.UpdateCustomRoleRequest.
 * Use `create(UpdateCustomRoleRequestSchema)` to create a new message.
 */
export const UpdateCustomRoleRequestSchema: GenMessage<UpdateCustomRoleRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 99);

/**
 * @generated from message chalk.server.v1.UpdateCustomRoleResponse
 */
export type UpdateCustomRoleResponse = Message<"chalk.server.v1.UpdateCustomRoleResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: repeated string permissions = 4;
   */
  permissions: string[];

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message chalk.server.v1.UpdateCustomRoleResponse.
 * Use `create(UpdateCustomRoleResponseSchema)` to create a new message.
 */
export const UpdateCustomRoleResponseSchema: GenMessage<UpdateCustomRoleResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 100);

/**
 * @generated from message chalk.server.v1.GetPermissionsForEnvironmentRequest
 */
export type GetPermissionsForEnvironmentRequest = Message<"chalk.server.v1.GetPermissionsForEnvironmentRequest"> & {
  /**
   * @generated from field: string environment_id = 1;
   */
  environmentId: string;
};

/**
 * Describes the message chalk.server.v1.GetPermissionsForEnvironmentRequest.
 * Use `create(GetPermissionsForEnvironmentRequestSchema)` to create a new message.
 */
export const GetPermissionsForEnvironmentRequestSchema: GenMessage<GetPermissionsForEnvironmentRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 101);

/**
 * @generated from message chalk.server.v1.GetPermissionsForEnvironmentResponse
 */
export type GetPermissionsForEnvironmentResponse = Message<"chalk.server.v1.GetPermissionsForEnvironmentResponse"> & {
  /**
   * @generated from field: repeated chalk.auth.v1.Permission permissions = 1;
   */
  permissions: Permission[];

  /**
   * @generated from field: repeated chalk.server.v1.RoleDescription roles = 2;
   */
  roles: RoleDescription[];
};

/**
 * Describes the message chalk.server.v1.GetPermissionsForEnvironmentResponse.
 * Use `create(GetPermissionsForEnvironmentResponseSchema)` to create a new message.
 */
export const GetPermissionsForEnvironmentResponseSchema: GenMessage<GetPermissionsForEnvironmentResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 102);

/**
 * @generated from message chalk.server.v1.GetProjectRequest
 */
export type GetProjectRequest = Message<"chalk.server.v1.GetProjectRequest"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;
};

/**
 * Describes the message chalk.server.v1.GetProjectRequest.
 * Use `create(GetProjectRequestSchema)` to create a new message.
 */
export const GetProjectRequestSchema: GenMessage<GetProjectRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 103);

/**
 * @generated from message chalk.server.v1.ProjectDescription
 */
export type ProjectDescription = Message<"chalk.server.v1.ProjectDescription"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string team_id = 3;
   */
  teamId: string;

  /**
   * @generated from field: optional string git_repo = 4;
   */
  gitRepo?: string;

  /**
   * @generated from field: map<string, google.protobuf.Value> internal_metadata = 5;
   */
  internalMetadata: { [key: string]: Value };

  /**
   * @generated from field: map<string, google.protobuf.Value> customer_metadata = 6;
   */
  customerMetadata: { [key: string]: Value };

  /**
   * @generated from field: optional string default_environment_id = 7;
   */
  defaultEnvironmentId?: string;
};

/**
 * Describes the message chalk.server.v1.ProjectDescription.
 * Use `create(ProjectDescriptionSchema)` to create a new message.
 */
export const ProjectDescriptionSchema: GenMessage<ProjectDescription> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 104);

/**
 * @generated from message chalk.server.v1.GetProjectResponse
 */
export type GetProjectResponse = Message<"chalk.server.v1.GetProjectResponse"> & {
  /**
   * @generated from field: chalk.server.v1.ProjectDescription project = 1;
   */
  project?: ProjectDescription;
};

/**
 * Describes the message chalk.server.v1.GetProjectResponse.
 * Use `create(GetProjectResponseSchema)` to create a new message.
 */
export const GetProjectResponseSchema: GenMessage<GetProjectResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_team, 105);

/**
 * How a team came to exist: provisioned by Chalk for a customer, or created by a user
 * through the self-service signup flow. Persisted on the Team row as the stringified
 * enum value name; rows written before this existed have no value and read back as
 * UNSPECIFIED.
 *
 * @generated from enum chalk.server.v1.TeamCreationType
 */
export enum TeamCreationType {
  /**
   * @generated from enum value: TEAM_CREATION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TEAM_CREATION_TYPE_CHALK_MANAGED = 1;
   */
  CHALK_MANAGED = 1,

  /**
   * @generated from enum value: TEAM_CREATION_TYPE_SELF_SERVICE = 2;
   */
  SELF_SERVICE = 2,
}

/**
 * Describes the enum chalk.server.v1.TeamCreationType.
 */
export const TeamCreationTypeSchema: GenEnum<TeamCreationType> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_team, 0);

/**
 * Account category supplied by signup, stored on Team as the stringified enum name.
 *
 * @generated from enum chalk.server.v1.TeamAccountType
 */
export enum TeamAccountType {
  /**
   * @generated from enum value: TEAM_ACCOUNT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TEAM_ACCOUNT_TYPE_INDIVIDUAL = 1;
   */
  INDIVIDUAL = 1,

  /**
   * @generated from enum value: TEAM_ACCOUNT_TYPE_BUSINESS = 2;
   */
  BUSINESS = 2,
}

/**
 * Describes the enum chalk.server.v1.TeamAccountType.
 */
export const TeamAccountTypeSchema: GenEnum<TeamAccountType> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_team, 1);

/**
 * @generated from service chalk.server.v1.TeamService
 */
export const TeamService: GenService<{
  /**
   * @generated from rpc chalk.server.v1.TeamService.GetEnv
   */
  getEnv: {
    methodKind: "unary";
    input: typeof GetEnvRequestSchema;
    output: typeof GetEnvResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.GetEnvIncludingArchived
   */
  getEnvIncludingArchived: {
    methodKind: "unary";
    input: typeof GetEnvIncludingArchivedRequestSchema;
    output: typeof GetEnvIncludingArchivedResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.GetEnvironments
   */
  getEnvironments: {
    methodKind: "unary";
    input: typeof GetEnvironmentsRequestSchema;
    output: typeof GetEnvironmentsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.GetAgent
   */
  getAgent: {
    methodKind: "unary";
    input: typeof GetAgentRequestSchema;
    output: typeof GetAgentResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.GetDisplayAgent
   */
  getDisplayAgent: {
    methodKind: "unary";
    input: typeof GetDisplayAgentRequestSchema;
    output: typeof GetDisplayAgentResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.GetTeam
   */
  getTeam: {
    methodKind: "unary";
    input: typeof GetTeamRequestSchema;
    output: typeof GetTeamResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.CreateTeam
   */
  createTeam: {
    methodKind: "unary";
    input: typeof CreateTeamRequestSchema;
    output: typeof CreateTeamResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.CreateProject
   */
  createProject: {
    methodKind: "unary";
    input: typeof CreateProjectRequestSchema;
    output: typeof CreateProjectResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.UpdateProject
   */
  updateProject: {
    methodKind: "unary";
    input: typeof UpdateProjectRequestSchema;
    output: typeof UpdateProjectResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.ArchiveProject
   */
  archiveProject: {
    methodKind: "unary";
    input: typeof ArchiveProjectRequestSchema;
    output: typeof ArchiveProjectResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.CreateEnvironment
   */
  createEnvironment: {
    methodKind: "unary";
    input: typeof CreateEnvironmentRequestSchema;
    output: typeof CreateEnvironmentResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.UpdateEnvironment
   */
  updateEnvironment: {
    methodKind: "unary";
    input: typeof UpdateEnvironmentRequestSchema;
    output: typeof UpdateEnvironmentResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.CreateVectorDBConfiguration
   */
  createVectorDBConfiguration: {
    methodKind: "unary";
    input: typeof CreateVectorDBConfigurationRequestSchema;
    output: typeof CreateVectorDBConfigurationResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.GetAvailablePermissions
   */
  getAvailablePermissions: {
    methodKind: "unary";
    input: typeof GetAvailablePermissionsRequestSchema;
    output: typeof GetAvailablePermissionsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.CreateServiceToken
   */
  createServiceToken: {
    methodKind: "unary";
    input: typeof CreateServiceTokenRequestSchema;
    output: typeof CreateServiceTokenResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.CreateServiceTokenTeamScoped
   */
  createServiceTokenTeamScoped: {
    methodKind: "unary";
    input: typeof CreateServiceTokenTeamScopedRequestSchema;
    output: typeof CreateServiceTokenTeamScopedResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.UpdateServiceTokenTeamScoped
   */
  updateServiceTokenTeamScoped: {
    methodKind: "unary";
    input: typeof UpdateServiceTokenTeamScopedRequestSchema;
    output: typeof UpdateServiceTokenTeamScopedResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.DeleteServiceTokenTeamScoped
   */
  deleteServiceTokenTeamScoped: {
    methodKind: "unary";
    input: typeof DeleteServiceTokenTeamScopedRequestSchema;
    output: typeof DeleteServiceTokenTeamScopedResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.ListServiceTokensTeamScoped
   */
  listServiceTokensTeamScoped: {
    methodKind: "unary";
    input: typeof ListServiceTokensTeamScopedRequestSchema;
    output: typeof ListServiceTokensTeamScopedResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.DeleteServiceToken
   */
  deleteServiceToken: {
    methodKind: "unary";
    input: typeof DeleteServiceTokenRequestSchema;
    output: typeof DeleteServiceTokenResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.ListServiceTokens
   */
  listServiceTokens: {
    methodKind: "unary";
    input: typeof ListServiceTokensRequestSchema;
    output: typeof ListServiceTokensResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.UpdateServiceToken
   */
  updateServiceToken: {
    methodKind: "unary";
    input: typeof UpdateServiceTokenRequestSchema;
    output: typeof UpdateServiceTokenResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.InviteTeamMember
   */
  inviteTeamMember: {
    methodKind: "unary";
    input: typeof InviteTeamMemberRequestSchema;
    output: typeof InviteTeamMemberResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.InviteTeamMemberWithTeamRole
   */
  inviteTeamMemberWithTeamRole: {
    methodKind: "unary";
    input: typeof InviteTeamMemberWithTeamRoleRequestSchema;
    output: typeof InviteTeamMemberWithTeamRoleResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.ExpireTeamInvite
   */
  expireTeamInvite: {
    methodKind: "unary";
    input: typeof ExpireTeamInviteRequestSchema;
    output: typeof ExpireTeamInviteResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.ListTeamInvites
   */
  listTeamInvites: {
    methodKind: "unary";
    input: typeof ListTeamInvitesRequestSchema;
    output: typeof ListTeamInvitesResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.ListTeamMembers
   */
  listTeamMembers: {
    methodKind: "unary";
    input: typeof ListTeamMembersRequestSchema;
    output: typeof ListTeamMembersResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.UpsertFeaturePermissions
   */
  upsertFeaturePermissions: {
    methodKind: "unary";
    input: typeof UpsertFeaturePermissionsRequestSchema;
    output: typeof UpsertFeaturePermissionsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.UpdateScimGroupSettings
   */
  updateScimGroupSettings: {
    methodKind: "unary";
    input: typeof UpdateScimGroupSettingsRequestSchema;
    output: typeof UpdateScimGroupSettingsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.GetTeamPermissions
   */
  getTeamPermissions: {
    methodKind: "unary";
    input: typeof GetTeamPermissionsRequestSchema;
    output: typeof GetTeamPermissionsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.GetPermissionsForEnvironment
   */
  getPermissionsForEnvironment: {
    methodKind: "unary";
    input: typeof GetPermissionsForEnvironmentRequestSchema;
    output: typeof GetPermissionsForEnvironmentResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.ArchiveEnvironment
   */
  archiveEnvironment: {
    methodKind: "unary";
    input: typeof ArchiveEnvironmentRequestSchema;
    output: typeof ArchiveEnvironmentResponseSchema;
  },
  /**
   * Chalk-employee-only: PERMISSION_CHALK_ADMIN is injected into a user agent
   * only for an @chalk.ai address, and no role grants it, so a customer cannot
   * reach this even as the owner of their own team. A service token can only
   * carry it if a Chalk employee deliberately minted one with it --
   * CreateServiceToken requires the permission to be a subset of the caller's
   * own, and GetAvailablePermissions does not offer it in the UI.
   *
   * @generated from rpc chalk.server.v1.TeamService.DeleteSelfSignupTeam
   */
  deleteSelfSignupTeam: {
    methodKind: "unary";
    input: typeof DeleteSelfSignupTeamRequestSchema;
    output: typeof DeleteSelfSignupTeamResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.DeactivateUser
   */
  deactivateUser: {
    methodKind: "unary";
    input: typeof DeactivateUserRequestSchema;
    output: typeof DeactivateUserResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.ReactivateUser
   */
  reactivateUser: {
    methodKind: "unary";
    input: typeof ReactivateUserRequestSchema;
    output: typeof ReactivateUserResponseSchema;
  },
  /**
   * Assigns a team-scoped role to a user (i.e. role assignment with no environment).
   *
   * @generated from rpc chalk.server.v1.TeamService.AssignTeamRole
   */
  assignTeamRole: {
    methodKind: "unary";
    input: typeof AssignTeamRoleRequestSchema;
    output: typeof AssignTeamRoleResponseSchema;
  },
  /**
   * Assigns an environment-scoped role to a user.
   *
   * @generated from rpc chalk.server.v1.TeamService.AssignEnvironmentRole
   */
  assignEnvironmentRole: {
    methodKind: "unary";
    input: typeof AssignEnvironmentRoleRequestSchema;
    output: typeof AssignEnvironmentRoleResponseSchema;
  },
  /**
   * Assigns an environment-scoped role to a SCIM group.
   *
   * @generated from rpc chalk.server.v1.TeamService.AssignScimGroupEnvironmentRole
   */
  assignScimGroupEnvironmentRole: {
    methodKind: "unary";
    input: typeof AssignScimGroupEnvironmentRoleRequestSchema;
    output: typeof AssignScimGroupEnvironmentRoleResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.DeleteScimGroup
   */
  deleteScimGroup: {
    methodKind: "unary";
    input: typeof DeleteScimGroupRequestSchema;
    output: typeof DeleteScimGroupResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.DeleteScimGroupUsers
   */
  deleteScimGroupUsers: {
    methodKind: "unary";
    input: typeof DeleteScimGroupUsersRequestSchema;
    output: typeof DeleteScimGroupUsersResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.CreateCustomRole
   */
  createCustomRole: {
    methodKind: "unary";
    input: typeof CreateCustomRoleRequestSchema;
    output: typeof CreateCustomRoleResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.DeleteCustomRole
   */
  deleteCustomRole: {
    methodKind: "unary";
    input: typeof DeleteCustomRoleRequestSchema;
    output: typeof DeleteCustomRoleResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.UpdateCustomRole
   */
  updateCustomRole: {
    methodKind: "unary";
    input: typeof UpdateCustomRoleRequestSchema;
    output: typeof UpdateCustomRoleResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.TeamService.GetProject
   */
  getProject: {
    methodKind: "unary";
    input: typeof GetProjectRequestSchema;
    output: typeof GetProjectResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_chalk_server_v1_team, 0);

